export default "__VITE_ASSET__DR0xM_xe__"